import { useState, useEffect } from 'react';
import localeZH from 'antd/es/locale/zh_CN';
import { asserts } from '../../utils';

const { Table: localeTable, Empty } = localeZH;

const fetchingLocale = {
  ...localeTable,
  emptyText: '加载中...',
};

const doneLocale = {
  ...localeTable,
  emptyText: Empty.description,
};

const useTableLocale = (initialFetchingStatus = true) => {
  const [isFetching, setIsFetching] = useState(initialFetchingStatus);
  const [locale, setLocale] = useState(fetchingLocale);

  useEffect(() => {
    isFetching ? setLocale(fetchingLocale) : setLocale(doneLocale);
  }, [isFetching]);

  const changeFetchingStatus = (status) => {
    setIsFetching(asserts.isExist(status) ? status : false);
  };

  return [locale, changeFetchingStatus];
};

export default useTableLocale;
